import { NgModule, InjectionToken } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LocationStrategy, HashLocationStrategy, CurrencyPipe } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AppRoutes } from './app.routes';
import 'rxjs/add/operator/toPromise';
import { Http } from '@angular/http';
import { HttpClientModule, HttpRequest } from '@angular/common/http';
import {
    AccordionModule, AutoCompleteModule, ButtonModule, CaptchaModule, CalendarModule, CarouselModule, ColorPickerModule, ChartModule,
    CheckboxModule, ChipsModule, CodeHighlighterModule, ConfirmDialogModule, SharedModule, ContextMenuModule, DataGridModule,
    DataListModule, DataScrollerModule, DataTableModule, DialogModule, DragDropModule, DropdownModule, EditorModule,
    FieldsetModule, FileUploadModule, GalleriaModule, GMapModule, GrowlModule, InputSwitchModule, InputTextModule,
    InputTextareaModule, LightboxModule, ListboxModule, MegaMenuModule, MenuModule, MenubarModule, MessagesModule,
    MultiSelectModule, OrderListModule, OrganizationChartModule, OverlayPanelModule, PaginatorModule, PanelModule,
    PanelMenuModule, PasswordModule, PickListModule, ProgressBarModule, RadioButtonModule, RatingModule, ScheduleModule,
    SelectButtonModule, SlideMenuModule, SliderModule, SpinnerModule, SplitButtonModule, StepsModule, TabMenuModule,
    TabViewModule, TerminalModule, TieredMenuModule, ToggleButtonModule, ToolbarModule, TooltipModule, TreeModule,
    TreeTableModule, ConfirmationService
} from 'primeng/primeng';

import { TextMaskModule, conformToMask } from 'angular2-text-mask';
import { UnmaskDirective } from './util/appUnmask.directive';

import { CurrencyMaskModule } from 'ng2-currency-mask';

import {
    DatatableService, DatatableModule, AuthService, HttpService, AuthConfig,
    AUTH_CONFIG, authServiceFactory, VersionTagModule
} from '@basis/angular-components';

import { CepPipe } from './util/pipe-cep';
import { FormatSelectItemPipe, FormatSelectItemPipeTopBar } from './util/pipe-selecao';
import { PipeCpfCnpj } from './util/pipe-cpf-cnpj';
import { TelefoneMaskPipe } from './util/pipe-telefone';
import { NumRegistroMaskPipe } from './util/pipe-numregistro';
import { NoSanitizePipe } from './util/no-sanitize.component';
import { PercentMaskPipe } from './util/pipe-percent';
import { AppComponent } from './app.component';
import { AppMenuComponent, AppSubMenu } from './app.menu.component';
import { AppTopBar } from './app.topbar.component';
import { AppFooter } from './app.footer.component';
import { InlineProfileComponent } from './app.profile.component';
import { AutenticacaoService } from './service/autenticacao.service';
import { Locale } from './util/locale.ptbr';
import { Helpers } from './util/helpers';
import { BreadcrumbService } from 'ng5-breadcrumb';
import { CustomBreadcrumbComponent } from './util/custom-breadcrumb.component';
import { PadraoService } from './service/padrao.service';
import { AuthGuard } from './autenticacao/auth.guard';
import { JwtHelper, AuthHttp } from 'angular2-jwt';
import { Erro403Component } from './erros';
import {
    BaseCrudNavigationComponent, BaseComponent, BaseListFilterComponent,
    BaseInfoComponent, BaseStepComponent, BaseListComponent, BaseCrudNoNavigationComponent
} from './base';

import {
    FormMaskTestComponent, FormSelectComponent, FormTextComponent, FormPercentComponent, TitleHeaderComponent,
    ValidationComponent, FormHiddenComponent, FormSwitchComponent, FormCalendarComponent, FormTextAreaComponent,
    FormMultiSelectComponent, FormNumberComponent, FormRadioComponent, FormSliderComponent, FormCheckComponent
} from './base/base-fields/components';

import {
    InstituicaoEnsinoCrudComponent, InstituicaoEnsinoComponent, InstituicaoEnsinoEtapa1Component,
    InstituicaoEnsinoEtapa2Component
} from './instituicao-ensino/index';

import {
    ModeloPadraoComponent, CrudModeloPadraoComponent,
    ModeloPadraoEtapa1Component, ModeloPadraoEtapa2Component
} from './modelo-padrao/index';

import {
    ModeloPadraoEmissaoDocComponent, CrudModeloPadraoEmissaoDocComponent, ModeloPadraoEmissaoDocEtapa1Component
} from './modelo-padrao-emissao-doc/index';

import { CertidaoComponent, CrudCertidaoComponent } from './certidao/index';
import { AlvaraComponent, CrudAlvaraComponent } from './alvara/index';

import { NaturezaTituloComponent, CrudNaturezaTituloComponent } from './natureza-titulo/index';
import { AreaFormacaoComponent, CrudAreaFormacaoComponent } from './area-formacao/index';
import { CursoComponent, CrudCursoComponent } from './curso/index';
import { ProfissaoComponent, CrudProfissaoComponent } from './profissao/index';

import {
    // PessoaFisicaComponent, CrudPessoaFisicaComponent,
    // CrudPessoaFisicaEtapa1Component, CrudPessoaFisicaEtapa2Component, CrudPessoaFisicaEtapa3Component,
    // CrudPessoaFisicaEtapa4Component, CrudPessoaFisicaEtapa5Component, CrudPessoaFisicaEtapa6Component,
    DataTableAnexoComponent
} from './pessoa-fisica/';

import {
    PessoaJuridicaComponent, PessoaJuridicaFormComponent, CrudPessoaJuridicaComponent,
    CrudPessoaJuridicaEtapa1Component, CrudPessoaJuridicaEtapa2Component, CrudPessoaJuridicaEtapa3Component, CrudPessoaJuridicaEtapa4Component
} from './pessoa-juridica/';

import {
    CrudConselhoRegionalComponent, ConselhoRegionalComponent, ConselhoRegionalEtapa1Component,
    ConselhoRegionalEtapa2Component
} from './conselho-regional/index';

import { ConsultarComunicacaoComponent, FilterComunicacaoComponent, ConsultarComunicacaoCrudComponent, ConsultarComunicacaoCrudEtapa1Component } from './consultar-comunicacao/index';

import { ModulosComponent } from './modulos/index';

import { RegistrosDelegaciaComponent, FilterRegistrosDelegaciaComponent, RegistrosDelegaciaCidadeComponent } from './registros-delegacia/index';

import { DelegaciaComponent, FilterDelegaciaComponent, DelegaciaCrudComponent, DelegaciaEtapa1Component, DelegaciaEtapa2Component } from './delegacia/index';

import { SolicitarComunicacaoComponent, SolicitarComunicacaoCrudComponent, SolicitarComunicacaoCrudEtapa1Component, SolicitarComunicacaoCrudEtapa2Component } from './solicitar-comunicacao/index';

import { ConsultarSituacaoCadastralComponent, FilterSituacaoCadastralComponent } from './consultar-situacao-cadastral/index';
import { AnexoComponent, EnderecoComponent, TelefoneComponent, UploadAnexoComponent } from './pessoa/index';

import { ConsultarPessoaComponent, FilterPessoaComponent } from './consultar-pessoa-modelo/index';
import { ConsultarPessoaFisicaComponent } from './consultar-pessoa-fisica/consultar-pessoa-fisica.component';
import { ConsultarPessoaJuridicaComponent } from './consultar-pessoa-juridica/consultar-pessoa-juridica.component';
import { CrudOrgaoExpedidorComponent, OrgaoExpedidorComponent } from './orgao-expedidor/index';
import { ValidarDocumentoComponent } from './validar-documentos/validar-documentos.component';
import { FileSizePipe } from 'app/util/file-size.pipe';
import { ObservableBlockPanel, ObservableLotacao, ObservableVariable, bObservableUsuario, ObservableBlockPanelDoc } from 'app/util/observable-util';
import { authHttpServiceFactory } from './autenticacao/auth.module';
import { NgProgressModule } from 'ngx-progressbar';
import { BlockUIModule } from 'primeng/primeng';
import { BaseBarProgressComponent } from './base/base-barprogress.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { GerenciarServicoComponent, GerenciarServicoCrudComponent, GerenciarServicoEtapa1Component, GerenciarServicoEtapa2Component, GerenciarServicoEtapa3Component } from './gerenciar-servico/index';
import { GerenciarServicoPessoaJuridicaComponent, GerenciarServicoPessoaJuridicaCrudComponent, GerenciarServicoPessoaJuridicaEtapa1Component, GerenciarServicoPessoaJuridicaEtapa2Component, GerenciarServicoPessoaJuridicaEtapa3Component } from './gerenciar-servico-pessoa-juridica/index';
import { GerenciarServicoGestorComponent, EncaminharServicoComponent, SolicitarComplementoComponent, TrocarResponsavelComponent } from './gerenciar-servico-gestor';
import { OficioComponent, OficioCrudComponent, OficioEtapa1Component, OficioEtapa2Component } from './oficio';
import { environment } from 'environments/environment';
import { CertidaoCnaipjComponent } from './certidao-cnaipj/certidao-cnaipj.component';
import { FilaServicoComponent } from './fila-servico/fila-servico.component';
// import { ConsultarCnaipjComponent } from './consultar-cnaipj/consultar-cnaipj.component';
@NgModule({
    imports: [
        // PdfViewerModule,
        // CurrencyMaskModule,
        BrowserModule,
        FormsModule,
        AppRoutes,
        BrowserAnimationsModule,
        ReactiveFormsModule,
        FieldsetModule,
        ConfirmDialogModule,
        GrowlModule,
        // AccordionModule,
        // AutoCompleteModule,
        // ButtonModule,
        // CaptchaModule,
        // CalendarModule,
        // CarouselModule,
        // ColorPickerModule,
        // ChartModule,
        // CheckboxModule,
        // ChipsModule,
        // CodeHighlighterModule,
        // ConfirmDialogModule,
        // SharedModule,
        // ContextMenuModule,
        // DataGridModule,
        // DataListModule,
        // DataScrollerModule,
        // DataTableModule,
        DialogModule,
        // DragDropModule,
        DropdownModule,
        // EditorModule,
        // FieldsetModule,
        // FileUploadModule,
        // GalleriaModule,
        // GMapModule,
        // GrowlModule,
        // InputSwitchModule,
        // InputTextModule,
        // InputTextareaModule,
        // LightboxModule,
        // ListboxModule,
        // MegaMenuModule,
        // MenuModule,
        // MenubarModule,
        // MessagesModule,
        // MultiSelectModule,
        // OrderListModule,
        // OrganizationChartModule,
        // OverlayPanelModule,
        // PaginatorModule,
        // PanelModule,
        // PanelMenuModule,
        // PasswordModule,
        // PickListModule,
        // ProgressBarModule,
        // RadioButtonModule,
        // RatingModule,
        // ScheduleModule,
        // SelectButtonModule,
        // SlideMenuModule,
        // SliderModule,
        // SpinnerModule,
        // SplitButtonModule,
        // StepsModule,
        // TabMenuModule,
        // TabViewModule,
        // TerminalModule,
        // TieredMenuModule,
        // ToggleButtonModule,
        // ToolbarModule,
        // TooltipModule,
        // TreeModule,
        // TreeTableModule,
        // TextMaskModule,
        NgProgressModule,
        BlockUIModule,
        DatatableModule.forRoot(),
        VersionTagModule
    ],
    declarations: [
        // NoSanitizePipe,
        // CepPipe,
        // PipeCpfCnpj,
        // TelefoneMaskPipe,
        // NumRegistroMaskPipe,
        FormatSelectItemPipeTopBar,
        // FileSizePipe,
        // PercentMaskPipe,
        AppComponent,
        AppMenuComponent,
        AppSubMenu,
        AppTopBar,
        AppFooter,
        InlineProfileComponent,
        // UnmaskDirective,

        // DataTableAnexoComponent,
        // CrudPessoaFisicaEtapa1Component,
        // CrudPessoaFisicaEtapa2Component,
        // CrudPessoaFisicaEtapa3Component,
        // CrudPessoaFisicaEtapa4Component,
        // CrudPessoaFisicaEtapa5Component,
        // CrudPessoaFisicaEtapa6Component,
        // CrudPessoaFisicaComponent,
        // PessoaFisicaComponent,

        // PessoaJuridicaComponent,
        // PessoaJuridicaFormComponent,
        // CrudPessoaJuridicaComponent,
        // CrudPessoaJuridicaEtapa1Component,
        // CrudPessoaJuridicaEtapa2Component,
        // CrudPessoaJuridicaEtapa3Component,
        // CrudPessoaJuridicaEtapa4Component,

        // AnexoComponent,
        // EnderecoComponent,
        // TelefoneComponent,
        // UploadAnexoComponent,

        // CrudOrgaoExpedidorComponent,
        // OrgaoExpedidorComponent,

        // ModeloPadraoComponent,
        // CrudModeloPadraoComponent,
        // ModeloPadraoEtapa1Component,
        // ModeloPadraoEtapa2Component,

        // CursoComponent,
        // CrudCursoComponent,

        // NaturezaTituloComponent,
        // CrudNaturezaTituloComponent,

        // AreaFormacaoComponent,
        // CrudAreaFormacaoComponent,

        // ProfissaoComponent,
        // CrudProfissaoComponent,

        // CertidaoComponent,
        // CrudCertidaoComponent,
        // AlvaraComponent,
        // CrudAlvaraComponent,

        // ValidarDocumentoComponent,

        // ModeloPadraoEmissaoDocComponent,
        // CrudModeloPadraoEmissaoDocComponent,
        // ModeloPadraoEmissaoDocEtapa1Component,

        // InstituicaoEnsinoCrudComponent,
        // InstituicaoEnsinoComponent,
        // InstituicaoEnsinoEtapa1Component,
        // InstituicaoEnsinoEtapa2Component,

        // CrudConselhoRegionalComponent,
        // ConselhoRegionalComponent,
        // ConselhoRegionalEtapa1Component,
        // ConselhoRegionalEtapa2Component,

        // ConsultarComunicacaoComponent,
        // FilterComunicacaoComponent,
        // ConsultarComunicacaoCrudComponent,
        // ConsultarComunicacaoCrudEtapa1Component,

        // RegistrosDelegaciaComponent,
        // FilterRegistrosDelegaciaComponent,
        // RegistrosDelegaciaCidadeComponent,

        // DelegaciaComponent,
        // FilterDelegaciaComponent,
        // DelegaciaCrudComponent,
        // DelegaciaEtapa1Component,
        // DelegaciaEtapa2Component,

        // SolicitarComunicacaoComponent,
        // SolicitarComunicacaoCrudComponent,
        // SolicitarComunicacaoCrudEtapa1Component,
        // SolicitarComunicacaoCrudEtapa2Component,

        // ConsultarSituacaoCadastralComponent,
        // FilterSituacaoCadastralComponent,

        // ConsultarPessoaComponent,
        // FilterPessoaComponent,

        // ConsultarPessoaFisicaComponent,
        // ConsultarPessoaJuridicaComponent,

        ModulosComponent,

        // BaseCrudNavigationComponent,
        // BaseInfoComponent,
        // BaseListComponent,
        // BaseListFilterComponent,
        // BaseListFilterPessoaComponent,
        // BaseStepComponent,
        // BaseListFilterComponent,
        // BaseCrudNoNavigationComponent,
        // BaseComponent,

        CustomBreadcrumbComponent,
        // BaseInfoComponent,
        // TitleHeaderComponent,

        BaseBarProgressComponent,
        Erro403Component,
        // FilaServicoComponent,
        // CertidaoCnaipjComponent,
        // ConsultarCnaipjComponent,

        // GerenciarServicoComponent,
        // GerenciarServicoCrudComponent,
        // GerenciarServicoEtapa1Component,
        // GerenciarServicoEtapa2Component,
        // GerenciarServicoEtapa3Component,
        // GerenciarServicoGestorComponent,
        // EncaminharServicoComponent,
        // TrocarResponsavelComponent,
        // SolicitarComplementoComponent,

        // OficioComponent,
        // OficioCrudComponent,
        // OficioEtapa1Component,
        // OficioEtapa2Component,

    ],
    providers: [
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        {
            provide: DatatableService,
            useClass: DatatableService,
            deps: [AuthHttp]
        },
        {
            provide: AuthHttp,
            useFactory: authHttpServiceFactory,
            deps: [Http]
        },
        {
            provide: AUTH_CONFIG,
            useValue: environment.auth
        },
        {
            provide: AuthService,
            deps: [HttpService, AUTH_CONFIG],
            useFactory: authServiceFactory
        },
        ConfirmationService,
        PadraoService,
        AutenticacaoService,
        FormatSelectItemPipe,
        BreadcrumbService,
        CurrencyPipe,
        TelefoneMaskPipe,
        NumRegistroMaskPipe,
        PipeCpfCnpj,
        CepPipe,
        NoSanitizePipe,
        HttpClientModule,
        Locale, AuthGuard,
        ObservableBlockPanel,
        ObservableLotacao,
        ObservableVariable,
        bObservableUsuario,
        ObservableBlockPanelDoc,
        Helpers,
        JwtHelper, AuthService, HttpService
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts